<template>
  <ct-login-page :product="appName">
    <ct-login-form
      :email.sync="form.email"
      :password.sync="form.password"
      :errors="errors"
      :email_label="$t('auth.email.label')"
      :email_placeholder="$t('auth.email.placeholder')"
      :password_label="$t('auth.password.label')"
      :password_placeholder="$t('auth.password.placeholder')"
      :login_label="$t('auth.submit')"
      @login="login()" />
  </ct-login-page>
</template>

<script>
export default {
  name: 'Login',

  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      // O CtLoginForm espera um objeto indexado por campo (errors.email,
      // errors.password), que e tambem o formato devolvido pela API em
      // body.errors. Inicializar como array quebrava o type check da prop.
      errors: {}
    }
  },

  methods: {
    login () {
      this.$auth.login({
        data: this.form,
        rememberMe: true,
        redirect: { name: 'home' },
        error: err => {
          /**
           * @TODO: Transformar o tratamento de erros de formulário num padrão.
           * Abstraí-lo o máximo possível e movê-lo para uma mixin do Vue ou algo
           * parecido para ser reutilizado em todos os demais formulário do sistema.
           */

          let body = err.response.data

          // Limpa as mensagens de erro anteriores
          this.errors = {}

          // Se existe um container de erros...
          if (body.errors) {
            this.errors = body.errors
          } else
          // Se existe um alerta de erro...
          if (body.error) {
            this.$snotify.warning(body.error, this.$t('alert.title.warning'))
          }
        }
      })
    }
  },

  computed: {
    appName () {
      return process.env.VUE_APP_NAME
    }
  },

  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n src="@/lang/locales.json"></i18n>
<i18n>
{
  "en-US": {
    "title": "Login",
    "links": {
      "register": "Request an account",
      "forgot": "Forgot my password"
    },
    "auth": {
      "email": {
        "label": "Email",
        "placeholder": "Email address"
      },
      "password": {
        "label": "Password",
        "placeholder": "Access password"
      },
      "submit": "Sign in"
    }
  },
  "pt-BR": {
    "title": "Login",
    "links": {
      "register": "Solicitar uma conta",
      "forgot": "Esqueci minha senha"
    },
    "auth": {
      "email": {
        "label": "E-mail",
        "placeholder": "Endereço de e-mail"
      },
      "password": {
        "label": "Senha",
        "placeholder": "Senha de acesso"
      },
      "submit": "Entrar"
    }
  }
}
</i18n>
